import { useEffect, useState } from "react";
import { Button, FloatingLabel, Form, Offcanvas } from "olive-react-myoneui";
import ProfileCard from "./ProfileCard";
import { createSubject } from "../../../api/subjectApis";
import { toast } from "react-toastify";

function AddOffcanvas({ show, onClose, getallSubjects }) {
  const [images, setImages] = useState([]); // always array
  const [name, setName] = useState("");

  useEffect(() => {
    if (show) {
      setImages([]);
      setName("");
    }
  }, [show]);

  const handleSubmit = async () => {
    if (!name.trim()) {
      toast.error("Subject title is required.");
      return;
    }

    if (!images || images.length === 0) {
      toast.error("Subject image is required.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", name);

      // Append each file with key "image" (must match multer.array("image"))
      images.forEach((file) => formData.append("image", file));

      // Debug: check what is being sent
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await createSubject(formData);

      if (response?.data?.success) {
        toast.success(response.data.message || "Subject added successfully!");
        onClose();
        await getallSubjects();
      } else {
        toast.error(response?.data?.message || "Failed to add subject.");
      }
    } catch (error) {
      console.error("Error creating subject:", error);
      toast.error(error?.response?.data?.message || "An error occurred.");
    }
  };

  return (
    <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
      <Offcanvas.Header closeButton backButton="Close">
        <Offcanvas.Title>Add Subject</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <p className="help-text fs-6 fw-semibold">
          Please fill the form below and select subject title.
        </p>
        <ProfileCard
          title="Upload Subject Picture"
          onFileSelect={setImages}
          multiple={true} // allow multiple
        />
        <FloatingLabel
          controlId="subjectTitleId"
          label="Subject Title"
          className="mb-4"
        >
          <Form.Control
            type="text"
            placeholder="Subject Title"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FloatingLabel>
      </Offcanvas.Body>
      <Offcanvas.Footer>
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Offcanvas.Footer>
    </Offcanvas>
  );
}

export default AddOffcanvas;
